// Copyright © 2023 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlayerState } from '../../../_contracts';
let VideoPlayerOnNetwork = class VideoPlayerOnNetwork extends Vue {
    constructor() {
        super(...arguments);
        this.isVideoPlaying = false;
        this.initEmited = false;
        this.player = null;
        this.eventHandlers = [];
    }
    get videoMetaLink() {
        return this.videoSrc + '&cId=' + this.videoAttrId + '&iid=' + this.videoAttrIdNumber;
    }
    onPlay(event) {
        if (typeof event.payload === 'undefined') {
            return;
        }
        const { playerId, autoplay, muted } = event.payload;
        if (playerId !== this.videoAttrId) {
            return;
        }
        this.initPlayer(autoplay, muted);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        if (window.ONTVsendCommand) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            window.ONTVsendCommand('play', this.videoAttrIdNumber, this.videoId);
        }
    }
    onPause(event) {
        if (typeof event.payload === 'undefined') {
            return;
        }
        const { playerId } = event.payload;
        if (playerId !== this.videoAttrId) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        if (window.ONTVsendCommand) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            window.ONTVsendCommand('pause', this.videoAttrIdNumber, this.videoId);
        }
    }
    onStateChanged(event) {
        if (this.player === null || typeof event.payload === 'undefined') {
            return;
        }
        const { playerId, state } = event.payload;
        if (playerId === this.videoAttrId) {
            return;
        }
        if (state === PlayerState.Playing) {
            this.player.pauseVideo();
        }
    }
    watchEvents() {
        if (!this.eventBus) {
            return;
        }
        this.eventHandlers = [
            this.eventBus.handle('ui:video-player.play', this.onPlay),
            this.eventBus.handle('ui:video-player.pause', this.onPause),
            this.eventBus.handle('ui:video-player.state-changed', this.onStateChanged)
        ];
    }
    clearEvents() {
        this.eventHandlers.forEach(handler => handler.unsubscribe());
    }
    /**
     * Initialises the YouTube player.
     *
     * @param autoplay - Determines whether the video should start playing
     *   immediately after the player has been initialised.
     * @param muted - Determine whether the video should be started with volume 0.
     */
    initPlayer(autoplay = false, muted = false) {
        this.emitInit();
        this.player = null;
    }
    emitInit() {
        if (this.initEmited) {
            return;
        }
        console.log('PlayerInit');
        this.$emit('init');
        this.initEmited = true;
    }
    get videoAttrIdNumber() {
        return this.videoAttrId.replace('uid-', '').replace('-video', '');
    }
    get videoId() {
        // https://video.onnetwork.tv/embed.php?sid=M3JYLDAsMTBH
        const newLink = this.videoSrc;
        const match = newLink.match(/sid=([^&]+)/);
        return match && match[1] ? match[1] : undefined;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    receiveMediaInfo(e) {
        try {
            if (!e.data.indexOf || (e.data.indexOf('onntv://') !== 0)) {
                return;
            }
            let com = { comm: '' };
            try {
                com = JSON.parse(e.data.substr(8));
            }
            catch (e) {
                com = { comm: '' };
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            if (com && com.comm === '') {
                return;
            }
            switch (com.comm) {
                case '':
                    break;
                case 'volumeset':
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    console.log(com.comm + ' ' + com.subject);
                    break;
                case 'playerLoaded':
                    // console.log('playerLoaded', true)
                    break;
                // eslint-disable-next-line no-fallthrough
                case 'adstarted':
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    console.log(com.comm);
                    this.emitInit();
                    break;
                case 'moviestarted':
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    console.log(com.comm);
                    this.emitInit();
                    break;
                case 'plstarttry':
                case 'ad25':
                case 'ad50':
                case 'ad75':
                case 'adcomplete':
                case 'adskipped':
                case 'adnotpresent':
                case 'advideoexcluded':
                case 'adblocked':
                case 'aderror':
                case 'viewablesend':
                case 'movieset':
                case 'moviecleared':
                case 'moviecompleted':
                case 'movie25':
                case 'movie50':
                case 'movie75':
                case 'adviewable':
                case 'movieviewable':
                case 'moviesetu':
                case 'visibilitychange':
                case 'moviesetdelayed':
                case 'visibilitychangeum':
                case 'movie95':
                case 'moviepaused':
                case 'movieresumed':
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    // @ts-ignore
                    console.log(com.comm);
                    break;
            }
        }
        catch (e) {
        }
    }
};
__decorate([
    Prop({
        type: Object,
        required: true
    })
], VideoPlayerOnNetwork.prototype, "baseVideoMetadata", void 0);
__decorate([
    Prop({
        type: Object,
        required: false
    })
], VideoPlayerOnNetwork.prototype, "eventBus", void 0);
__decorate([
    Prop({
        type: String,
        required: true
    })
], VideoPlayerOnNetwork.prototype, "videoAttrId", void 0);
__decorate([
    Prop({
        type: String,
        required: false
    })
], VideoPlayerOnNetwork.prototype, "videoAdsTag", void 0);
__decorate([
    Prop({
        type: String,
        required: true
    })
], VideoPlayerOnNetwork.prototype, "videoSrc", void 0);
__decorate([
    Prop({
        type: String,
        required: false
    })
], VideoPlayerOnNetwork.prototype, "videoClass", void 0);
__decorate([
    Prop({
        type: String,
        required: true
    })
], VideoPlayerOnNetwork.prototype, "origin", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    })
], VideoPlayerOnNetwork.prototype, "shouldInit", void 0);
VideoPlayerOnNetwork = __decorate([
    Component({
        name: 'VideoPlayerOnNetwork',
        mounted() {
            this.$nextTick(() => {
                if (this.shouldInit) {
                    this.initPlayer();
                }
            });
            window.addEventListener('message', this.receiveMediaInfo);
            this.watchEvents();
        },
        beforeDestroy() {
            if (this.player && this.player.destroy) {
                this.player.destroy();
            }
            this.player = null;
            this.clearEvents();
            window.removeEventListener('message', this.receiveMediaInfo);
        },
        template: `
    <div>
    <component :is="'script'" type="text/javascript" :src="videoMetaLink" async="true"/>
    <div :id="videoAttrId" :class="videoClass" ref="onVideo"/>
    </div>
  `
    })
], VideoPlayerOnNetwork);
export { VideoPlayerOnNetwork };
export default VideoPlayerOnNetwork;
